import React, { useEffect, useState } from 'react';
import { bankDataAPI } from '../lib/api';
import { AlertTriangle } from 'lucide-react';

// Fintable deja de sincronizar el banco cada 90 dias (normativa PSD2).
// Avisamos cuando la ultima transaccion bancaria tiene mas de THRESHOLD dias.
const THRESHOLD_DAYS = 7;

export function BankSyncAlert() {
  const [days, setDays] = useState(null);
  const [lastDate, setLastDate] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const summary = await bankDataAPI.getSummary();
        const ltd = summary?.last_transaction_date;
        if (!ltd || !mounted) return;
        const last = new Date(ltd + 'T00:00:00');
        const diff = Math.floor((Date.now() - last.getTime()) / (1000 * 60 * 60 * 24));
        setDays(diff);
        setLastDate(last);
      } catch (e) {
        // ceo/manager only; ignore errors silently
      }
    })();
    return () => { mounted = false; };
  }, []);

  if (days === null || days <= THRESHOLD_DAYS) return null;

  return (
    <div
      className="flex items-start gap-3 rounded-lg border border-amber-300 bg-amber-50 p-4 text-amber-900"
      data-testid="bank-sync-alert"
    >
      <AlertTriangle className="w-5 h-5 mt-0.5 flex-shrink-0 text-amber-600" />
      <div className="text-sm">
        <p className="font-semibold" data-testid="bank-sync-alert-title">
          ⚠️ Banco sin sincronizar desde hace {days} días
        </p>
        <p className="mt-1 text-amber-800">
          La última transacción bancaria es del{' '}
          {lastDate?.toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' })}.
          Fintable deja de sincronizar cada 90 días por la normativa PSD2. Vuelve a conectar tu banco
          en Fintable para actualizar los movimientos.
        </p>
      </div>
    </div>
  );
}
